export default "__VITE_ASSET__Cgbb7nkU__"